import styled from 'styled-components6';
import { CarouselContrast } from './CarouselCounts';
import { MediaVariants } from './MediaCarousel';

export const ButtonContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'variant', //remove console warning of invalid prop passed to HTML element
})<{ variant: MediaVariants }>`
    //default hide the buttons for light variant
    visibility: ${({ variant }) =>
        variant === 'light' ? 'hidden' : 'visible'};
    opacity: ${({ variant }) => (variant === 'light' ? '0' : '1')};
    transition: visibility 0.2s ease-in-out, opacity 0.2s ease-in-out;
`;

export const PrevButton = ({
    onButtonClick,
    variant,
}: {
    onButtonClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    variant: MediaVariants;
}): JSX.Element => {
    const backgroundColor =
        variant === 'light' ? 'rgba(255, 255, 255, 0.9)' : CarouselContrast;
    const fill = variant === 'light' ? '#1E1E1E' : 'white';
    return (
        <div
            style={{
                position: 'absolute',
                top: 'calc(50% - 12px)',
                left: '16px',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
            onClick={(e) => onButtonClick(e)}
            role="button"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    width="24"
                    height="24"
                    rx="12"
                    fill={backgroundColor}
                    shapeRendering="geometricPrecision"
                />
                <path
                    d="M13.5 16L9.5 12L13.5 8"
                    stroke={fill}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};

export const NextButton = ({
    onButtonClick,
    variant,
}: {
    onButtonClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
    variant: MediaVariants;
}): JSX.Element => {
    const backgroundColor =
        variant === 'light' ? 'rgba(255, 255, 255, 0.9)' : CarouselContrast;
    const fill = variant === 'light' ? '#1E1E1E' : 'white';
    return (
        <div
            style={{
                position: 'absolute',
                top: 'calc(50% - 12px)',
                right: '16px',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
            onClick={(e) => onButtonClick(e)}
            role="button"
        >
            <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect
                    width="24"
                    height="24"
                    rx="12"
                    fill={backgroundColor}
                    shapeRendering="geometricPrecision"
                />
                <path
                    d="M10.5 8L14.5 12L10.5 16"
                    stroke={fill}
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </div>
    );
};
